// DEPENDENCIES
import React from 'react';
import Autocomplete from 'react-google-autocomplete';

// INNER IMPORTS
import './ServiceForm.css';

const ServiceForm = props => {

    return (
        <div className="serviceForm rtl">
            <div className="leftPart">
                <input type="text" name="name" placeholder="שם?" onChange={props.updateValue} value={props.name}
                       className={(props.userShouldEnter && props.userShouldEnter.indexOf("name")>-1?"required":null)}/>
            </div>
            <div className="rightPart">
                <Autocomplete
                    id="autocomplete"
                    onPlaceSelected={(place) => {props.updateLocation(place)}}
                    types={['geocode', 'establishment']}
                    className={(props.userShouldEnter && props.userShouldEnter.indexOf("location")>-1?"required":null)}
                    placeholder="הכניסו מיקום"
                />

                {/*<input type="text" name="email" placeholder="Your email?" onChange={props.updateValue} value={props.email}/>*/}
            </div>
            <div className="bottomPart">
                {props.desc ? null : <div className="text">עוד  משהו?</div>}
                <textarea
                    type="text"
                    name="desc"
                    onChange={props.updateValue}
                    value={props.desc}
                    maxLength="5000"
                    className={(props.userShouldEnter && props.userShouldEnter.indexOf("desc")>-1?"required":null)}/>
            </div>
        </div>
    )
};

export default ServiceForm;



// WEBPACK FOOTER //
// ./src/Components/Users/Submit/ServiceForm.js